export default __webpack_public_path__ + "static/media/addOnBenefitshelpHighlight@2x.3438ed70.png";